import { connect } from 'react-redux';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import onChangeTable from './Handlers/onChangeTable';
import onChangeSearch from './Handlers/onChangeSearch';
import onSubmitSearch from './Handlers/onSubmitSearch';
import onChangeFilter from './Handlers/onChangeFilter';

import onClickNewSupplier from './Handlers/onClickNewSupplier';
import onCloseSupplierModal from './Handlers/onCloseSupplierModal';
import didCreateSupplier from './Handlers/didCreateSupplier';
import didDeleteSupplier from './Handlers/didDeleteSupplier';

const mapStateToProps = (state) => ({
  suppliers: state.screens.Suppliers.suppliers,
  searchTerm: state.screens.Suppliers.searchTerm,
  filters: state.screens.Suppliers.filters,
  pagination: state.screens.Suppliers.pagination,
  fetching: state.screens.Suppliers.fetching,
  showSupplierModal: state.screens.Suppliers.showSupplierModal
});

const actionCreators = {
  componentDidMount,
  onChangeTable,
  onClickNewSupplier,
  onCloseSupplierModal,
  didCreateSupplier,
  didDeleteSupplier,

  onChangeSearch,
  onSubmitSearch,
  onChangeFilter
};

export default connect(mapStateToProps, actionCreators)(Component);
